define('router',[
  'backbone',
  'jquery',
  '_',
  'URIjs/URI',

  /* pages and modules */
  'pages/main_page_view',

  'pages/ad_form/ad_form_page_view',
  'pages/ads/ads_page_view',
  'pages/help/help_page_view',
  'pages/home/home_page_view',
  'pages/media/media_page_view',
  'pages/news/news_page_view',
  'pages/news_form/news_form_page_view',
  'pages/overview/overview_page_view',
	'pages/player/player_page_view',
	'pages/player/player_form_page_view',
  'pages/settings/settings_page_view',
  'pages/templates/templates_page_view',
  'pages/campaigns/campaigns_page_view',
  'pages/content_recommendations/content_recommendations_page_view',

  'session',
  'modules/user/user_model'
], function (Backbone, $, _, URI,
             PageView,
             AdFormView,
             AdsView,
             HelpView,
             HomeView,
             MediaView,
             NewsView,
             NewsFormView,
             OverviewView,
						 PlayerView,
						 PlayerFormView,
             SettingsView,
             TemplatesView,
             WeeklyOffersView,
             ContentRecommendationsView,
             session,
             user) {
  'use strict';
  var Router = Backbone.Router.extend({
    initialize: function (options) {
      _.extend(this, options);

      // init the page view wrapper
      this.pageView = new PageView({el: '.app'});

      // // render the page view wrapper
      // this.pageView.render();

      // put stuff that's only supposed to fire once and only once on init here
      this.once('route', function () {

        // if the app is uninitialized the loading-text is shown
        this.pageView.$el.removeClass('uninitialized');

      }, this);

      // event for all routing, for specific routes use 'route:routename'
      this.on('route', function (route) {

        if (this.pageView.model.get('currentRoute')) {
          this.pageView.model.set('previousRoute', this.pageView.model.get('currentRoute'));
        }

        /*
         if (this.currentView) {
         this.pageView.model.set('hasSidebar', this.currentView.hasSidebar);
         }
         */

        this.pageView.model.set('state', route);

        this.pageView.model.set('currentRoute', route);

        window.scrollTo(0, 0);
      });

      // Listen to navigate events from page view (or any other place)
      this.listenTo(Backbone, 'navigate', function (url) {
/*        if (this.pageView.formDirty) {
          this.pageView.showError('formDirty');
        } else {
          this.navigate(url, {trigger: true, replace: false});
        }*/
        this.navigate(url, {trigger: true, replace: false});
      }, this);

      this.listenTo(Backbone, 'navigate_login', function () {
        var fragment = Backbone.history.fragment;
        this.navigate('no_route', {trigger: true, replace: true});

        setTimeout(function () {
          this.navigate(fragment, {trigger: true, replace: true});
        }.bind(this), 0);

      }, this);

      $(document).ajaxError(function (event, jqxhr) {
        if (jqxhr.status === 401) {
          if (this.currentView) {
            this.currentView.remove();
          }
          user.clear();
          this.pageView.showLogin();
        }
      }.bind(this));

      // Lets go!
      Backbone.history.start({pushState: true});
      
    },
    routes: {
      '': 'home',
      'ads(?*querystring)': 'ads',
      'ads/new(?*querystring)': 'create_ad',
      'ads/:id/edit': 'edit_ad',

      'help': 'help',
      
      'login': 'login',
      'logout': 'logout',

      'media': 'media',

      'news': 'news',
      'news/new': 'edit_news_item',
      'news/:id/edit': 'edit_news_item',

      'overview': 'overview',
			'players/:id(?*querystring)': 'player',
			'players/:id/form(?*querystring)': 'player_form',

      'settings': 'settings',

      'templates(?*querystring)': 'templates',

      'campaigns': 'campaigns',
      'campaigns/:id/edit': 'edit_campaign',

      'content_recommendations': 'content_recommendations',
      
      '*path': 'error_404'
    },

    currentView: undefined,
    app: undefined,

    loadView: function (View, opts) {
      var self = this,
        options = {},
        defaults = {app: this.app, el: '.js-page-content'};

      _.extend(options, opts, defaults);

      if (self.currentView) {
        self.currentView.remove();
      }

      if (user.has('id')) {

        // this is the only way to update the expire date on the cookie for now...
        user.fetch();

        self.currentView = new View(options);
        return self.currentView;
      } else {

        user.fetch().then(function (result) {
          if (result.id) {
            self.currentView = new View(options);
            return self.currentView;
          }
        });
      }

    },

    /* Route functions */
    ads: function (querystring) {
      this.pageView.model.set({
        pageTitle: _.t('page_titles.my_ads')
      });

      var params = URI.parseQuery(querystring) || {};
      this.loadView(AdsView, {params: params});
    },

    create_ad: function (querystring) {
      this.pageView.model.set({
        pageTitle: _.t('page_titles.create_ad')
      });

      var params = URI.parseQuery(querystring) || {};
      this.loadView(AdFormView, {params: params, is_campaign: false});
    },

    edit_ad: function (ad_id) {
      this.pageView.model.set({
        pageTitle: _.t('page_titles.edit_ad')
      });
      this.loadView(AdFormView, {ad_id: ad_id, is_campaign: false});
    },

    help: function () {
      this.pageView.model.set({
        pageTitle: _.t('page_titles.help')
      });
      this.loadView(HelpView);
    },

    home: function () {
      this.pageView.model.set({
        pageTitle: _.t('page_titles.home')
      });
      this.loadView(HomeView);
    },

    login: function () {
      var href = session.get('apiBaseUrl') + '/user/login?redirectUrl=' + session.get('oidcReturnUrl');
      window.location.href = href;
    },

    logout: function () {
      if(session.get('oidc') === 'true') {
        var href = session.get('apiBaseUrl') + '/user/logout';
        window.location.href = href;
      } else {
        $.get(session.get('apiUrl') + '/logout', function () {
          window.location = '/';
        });
      }
    },

    media: function () {
      this.pageView.model.set({
        pageTitle: _.t('page_titles.my_media')
      });
      this.loadView(MediaView);
    },

    news: function () {
      this.pageView.model.set({
        pageTitle: _.t('page_titles.news')
      });
      this.loadView(NewsView);
    },

    edit_news_item: function (news_item_id) {
      this.pageView.model.set({
        pageTitle: _.t('page_titles.edit_news_item')
      });
      this.loadView(NewsFormView, {news_item_id: news_item_id});
    },

    overview: function () {
      this.pageView.model.set({
        pageTitle: _.t('page_titles.overview')
      });
      this.loadView(OverviewView);
    },

    player: function (player_id, querystring) {
      this.pageView.model.set({
        pageTitle: _.t('page_titles.overview')
      });
      var params = URI.parseQuery(querystring) || {};
      this.loadView(PlayerView, {player_id: player_id, params: params});
		},
		
		player_form: function (player_id, querystring) {
      this.pageView.model.set({
        pageTitle: _.t('page_titles.overview')
      });
      var params = URI.parseQuery(querystring) || {};
      this.loadView(PlayerFormView, {player_id: player_id, params: params});
    },

    settings: function () {
      this.pageView.model.set({
        pageTitle: _.t('page_titles.settings')
      });
      this.loadView(SettingsView);
    },

    templates: function (querystring) {
      this.pageView.model.set({
        pageTitle: _.t('page_titles.templates')
      });
      var params = URI.parseQuery(querystring) || {};
      this.loadView(TemplatesView, {params: params});
    },

    campaigns: function (querystring) {
      this.pageView.model.set({
        pageTitle: _.t('page_titles.campaigns')
      });

      var params = URI.parseQuery(querystring) || {};
      this.loadView(WeeklyOffersView, {params: params});
    },
    
    edit_campaign: function (booking_id) {
      this.pageView.model.set({
        pageTitle: _.t('page_titles.edit_ad')
      });
      this.loadView(AdFormView, {ad_id: booking_id, is_campaign: true});
    },

    content_recommendations: function (querystring) {
      this.pageView.model.set({
        pageTitle: _.t('page_titles.content_recommendations')
      });

      var params = URI.parseQuery(querystring) || {};
      this.loadView(ContentRecommendationsView, {params: params});
    },
  });

  return Router;

});

